import React, { useEffect, useState } from "react";
import PageHeader from "../components/PageHeader";
import Help from "../components/Help";
import { helpPagesData } from "../utils/helper";
import { NavLink, useNavigate } from "react-router-dom";
import arrow from "../assets/arrow.svg";
import { fetchSectionList, fetchTemplateList } from "../action/sectiondata";
import Paginate from "../components/pagination";
import { Spinner } from "react-bootstrap";


const Section = () => {
    const [activeTab, setActiveTab] = useState("templates");
    const [loading, setLoading] = useState(false);
    const [sortField, setSortField] = useState("createdAt");
    const [sortOrder, setSortOrder] = useState("desc"); // asc / desc
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [pagination, setPagination] = useState({
        page: 1,
        limit: 10,
        total: 0
    });

    const [search, setSearch] = useState("");

    const handleTabClick = (tab) => {
        setActiveTab(tab);
        setPagination((p) => ({ ...p, page: 1 })); // reset page
    };

    const fetchData = async () => {
        setLoading(true);
        const { page, limit } = pagination;

        let response;

        if (activeTab === "templates") {
            response = await fetchTemplateList(page, limit, search, sortField, sortOrder);
        } else {
            response = await fetchSectionList(page, limit, search, sortField, sortOrder);
        }

        if (response?.status === 1) {
            setData(response.data.list);
            setPagination((p) => ({
                ...p,
                total: Math.ceil(response.data.total / p.limit)   // ← FIXED
            }));
        }
        setLoading(false);
    };

    useEffect(() => {
        fetchData();
    }, [activeTab, pagination.page, pagination.limit, search, sortField, sortOrder]);

    const renderSortArrow = (field) => {
        if (sortField !== field) return "↕"; // no sort active yet
        return sortOrder === "asc" ? "↑" : "↓";
    };

    const handleSort = (field) => {
        if (sortField === field) {
            setSortOrder(sortOrder === "asc" ? "desc" : "asc");
        } else {
            setSortField(field);
            setSortOrder("asc"); // default
        }
    };
    const handlePageChange = (newPage) => {
        setPagination((p) => ({ ...p, page: newPage }));
    };

    const handlePageSizeChange = (newLimit) => {
        setPagination((p) => ({ ...p, limit: newLimit, page: 1 }));
    };

    return (
        <div>
            <PageHeader pageTitle="Section Masters">
       
                    <Help
                        title={helpPagesData.pages.title}
                        message={helpPagesData.pages.message}
                        items={helpPagesData.pages.items}
                    />
                    {activeTab === "templates" && (
                        <NavLink to="/section/add-template" className="btn-black">
                            Create Template
                        </NavLink>
                    )}

            </PageHeader>

            <div className="page-container">

                {/* TAB HEADERS */}
                <div className="theme-card p-4">
                    <div className="button-flex">
                        <button
                            className={`tab-btn ${activeTab === "templates" ? "active" : ""}`}
                            onClick={() => handleTabClick("templates")}
                        >
                            Templates
                        </button>

                        <button
                            className={`tab-btn ${activeTab === "sections" ? "active" : ""}`}
                            onClick={() => handleTabClick("sections")}
                        >
                            Sections
                        </button>
                    </div>

                    {/* OPTIONAL SEARCH */}
                    {/* <input
                        type="text"
                        className="form-control mb-3"
                        placeholder="Search..."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    /> */}

                    <div className="table-responsive">
                        {loading ? (
                            <div className="center-div">
                                <Spinner size="md" />
                            </div>
                        ) : (
                            <table className="pages-table">
                                <thead>
                                    <tr>
                                        <th>
                                            {activeTab === "templates" ? "Template Name" : "Section Name"}
                                        </th>
                                        <th
                                            onClick={() => handleSort("createdAt")}
                                            className="sortable"
                                        >
                                            Date Created {renderSortArrow("createdAt")}
                                        </th>
                                        <th style={{ textAlign: "center" }}>Actions</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {data.length > 0 ? (
                                        data.map((item) => (
                                            <tr key={item._id}>
                                                <td>{item.label || item.type || item.data?.title}</td>
                                                <td>{new Date(item.createdAt).toLocaleDateString()}</td>

                                                <td style={{ textAlign: "center" }}>
                                                    {activeTab === "templates" && (
                                                        <img
                                                            src={arrow}
                                                            alt="view"
                                                            className="view-icon"
                                                            onClick={() => navigate(`/section/template/${item._id}`)}
                                                        />
                                                    )}
                                                    {activeTab === "sections" && (
                                                        <img
                                                            src={arrow}
                                                            alt="view"
                                                            className="view-icon"
                                                            onClick={() => navigate(`/section/section-detail/${item._id}`)}
                                                        />
                                                    )}

                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="3" className="text-center py-4">
                                                No data found.
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        )}
                    </div>

                    {/* PAGINATION */}
                    {Boolean(pagination.total) && (
                        <Paginate
                            currentPage={pagination.page}
                            totalPages={pagination.total}
                            onPageChange={handlePageChange}
                            pageSize={pagination.limit}
                            onPageSizeChange={handlePageSizeChange}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export default Section;
